<template>
  <div class="achievement-comparison-topBar">
    <div class="btn-list">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <div class="select-list">
      <!-- <div style="margin-left: 20px">
        <span style="font-weight: bold; color: #0066cc">对比考试：</span>
        <span>{{ examInfoList[0].gradeName + examInfoList[0].title }}</span
        >/<span>{{ examInfoList[0].subTitle }}</span>
      </div>
      <div>
        <span style="font-weight: bold; color: #0066cc">被对比考试：</span>
        <span>{{ examInfoList[1].gradeName + examInfoList[1].title }}</span
        >/<span>{{ examInfoList[1].subTitle }}</span>
      </div> -->
      <!-- <div>
        <span style="font-weight: bold; color: #0066cc">对比考试：</span>
        <span v-for="(item, index) in examInfoList" :key="index">
          {{ item.title }}-{{ item.subTitle }}
        </span>
      </div> -->
    </div>
    <div class="select-list">
      <el-button v-hasPermi="'sc:grademultipleexamination:export'" size="small" type="success" @click="derivedScore">导出</el-button>
      <el-button type="primary" size="small" @click="chartDialogShow"
        >查看成绩柱状图</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["examInfoList"],
  data() {
    return {};
  },
  methods: {
    chartDialogShow() {
      this.$emit("chartDialogShow", true);
    },
    derivedScore() {
      this.$emit('derivedScore');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementComparisonTopBar.scss";
</style>